export const PUBLIC = 'Public';
export const PRIVE = 'Prive';

export const DOMAINE_EMPLACEMENT = [
  { name: PUBLIC, libelle: 'adresseEmplacement.public' },
  { name: PRIVE, libelle: 'adresseEmplacement.prive' },
];
